import { mapKeysToCamelCase } from '@skytech/utils'

import { API_ROUTE_ADMIN_REPORTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { ReportFilters } from './types'

export type OnboardingReportOriginal = {
  employee_name: string
  contact_number: string | null
  contact_email: string | null
  employee_number: string | null
  company: string | null
  department: string | null
  start_date: string | null
  created_date: string | null
  created_by: string | null
  last_updated_date: string | null
  last_updated_by: string | null
  status: string
  reason_comment: string
}

const IS_NEW_BACKEND_API = true

export const getOnboardingReports = async ({
  toDate,
  fromDate,
  isGlobal,
  selectedCustomer,
}: ReportFilters) => {
  if (!fromDate || !toDate) throw Error('Missing date range filters!')

  const searchParams = new URLSearchParams()
  searchParams.append('fromDate', fromDate)
  searchParams.append('toDate', toDate)
  searchParams.append('isGlobal', isGlobal.toString())
  searchParams.append('customerId', String(selectedCustomer || ''))

  const reports = await get<OnboardingReportOriginal[]>(
    `${API_ROUTE_ADMIN_REPORTS}/onboarding?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )

  return mapKeysToCamelCase(reports)
}
